module.exports = __webpack_public_path__ + "img/PTT.fee307bf.png";